import React from 'react'
import VolumeRetrieveForm from './VolumeRetrieveForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function CreateVolumeRetrieve() {
  SetTitle('Market Screener')
  return (
    <Header
      iconClass="fa-solid fa-chart-line fa-xl"
      title="Market Screener"
    >
      <VolumeRetrieveForm />
    </Header>
  )
}